const getPatientCity = ({ patient, value, billing = false }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const address = billing ? patient['Billing Address Information'] : patient['Address Information'];
  if (address && address.City) {
    return address.City.toUpperCase();
  }
  return null;
};

export default getPatientCity;



// WEBPACK FOOTER //
// ./src/utils/print/getPatientCity.js